import Immutable from 'immutable';

const initialState = Immutable.Map();

function updateStarted(state, payload) {
  return state.mergeIn([payload.id.toString(), 'update'], {
    completed: false,
    failed: false,
    errors: {},
    loading: true,
  });
}

function updateCompleted(state, payload) {
  return state.mergeIn([payload.id.toString(), 'update'], {
    completed: true,
    failed: false,
    errors: {},
    loading: false,
  });
}

function updateFailed(state, payload) {
  return state.mergeIn([payload.id.toString(), 'update'], {
    completed: false,
    failed: true,
    errors: payload.errors,
    loading: false,
  });
}

export default function reducer(state = initialState, { type, payload }) {
  return state.withMutations((state) => {
    return (
      {
        BOOKABLE_TEMPLATE_UPDATE: updateStarted,
        BOOKABLE_TEMPLATE_UPDATE_COMPLETED: updateCompleted,
        BOOKABLE_TEMPLATE_UPDATE_FAILED: updateFailed,
      }[type] || (() => state)
    )(state, payload);
  });
}
